import { SimpleThumbnail, TruncateWithTooltip } from "@kaltura/mediaspace-shared-ui";
import { formatEntryThumbnailUrl } from "@kaltura/mediaspace-shared-utils";
import { KalturaPlayableEntry } from "kaltura-typescript-client/api/types/KalturaPlayableEntry";
import { KalturaEntryType } from "kaltura-typescript-client/api/types/KalturaEntryType";
import { Stack } from "@kaltura/mediaspace-shared-styled";
import { SearchAndSelectEntry } from "@kaltura/mediaspace-shared-types";
import { styled } from "@mui/material";
import { CellSkeleton } from "./CellSkeleton";

interface EntryNameCellProps {
    entry: SearchAndSelectEntry;
}

const thumbWidth = 85;
const thumbHeight = 48;

/**
 * Media table cell with entry thumbnail and name for the "name" column
 */
export const EntryNameCell = ({ entry }: EntryNameCellProps) => {
    const isPlaylist = entry.entry.type === KalturaEntryType.playlist;

    return (
        <Stack direction={"row"} gap={2} alignItems={"center"}>
            <StyledThumbnailContainer>
                <SimpleThumbnail
                    thumbnailUrl={
                        isPlaylist
                            ? undefined
                            : formatEntryThumbnailUrl(entry.entry.thumbnailUrl, thumbWidth, thumbHeight)
                    }
                    isPlaylist={isPlaylist}
                    name={""}
                    duration={(entry.entry as KalturaPlayableEntry).duration}
                    durationVariant={"tight"}
                />
            </StyledThumbnailContainer>
            <TruncateWithTooltip text={entry.entry.name} lines={2}>
                <div>{entry.entry.name}</div>
            </TruncateWithTooltip>
        </Stack>
    );
};

/**
 * Skeleton for EntryNameCell
 */
export const EntryNameCellSkeleton = () => {
    return (
        <Stack direction={"row"} gap={2} alignItems={"center"}>
            <StyledThumbnailContainer>
                <CellSkeleton variant={"rectangular"} width={"100%"} height={"100%"} />
            </StyledThumbnailContainer>
            <CellSkeleton variant={"rectangular"} />
        </Stack>
    );
};

const StyledThumbnailContainer = styled("div")(({ theme }) => ({
    position: "relative",
    width: thumbWidth,
    height: thumbHeight,
    minWidth: thumbWidth,
    minHeight: thumbHeight,
    [theme.breakpoints.down("sm")]: {
        display: "none",
    },
}));
